import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
        <Reveal className="lg:col-span-1">
          <SectionHeading
            eyebrow="常见问题"
            title="投稿前，这些事你可能想知道"
            desc="关于匿名保护、审核时长与内容责任，我们把最常被问到的问题整理在这里。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-800 text-sm font-medium whitespace-nowrap hover:bg-secondary-200 transition-colors"
          >
            查看完整问答
            <i className="ri-arrow-right-line"></i>
          </Link>
        </Reveal>

        <Reveal className="lg:col-span-2" delay={100}>
          <FaqAccordion items={faqs.slice(0, 5)} />
        </Reveal>
      </div>
    </section>
  );
}